/**
 * Exported so config/app-index.ts can interpolate it into the inline dark-mode
 * bootstrap script — that script runs before hydration and can't import this module,
 * so at least the prefix values themselves have a single source of truth.
 */
export const DARK_MODE_EXCLUDED_PATH_PREFIXES: readonly string[] = ['/admin'];

/**
 * Non-admin pages not yet styled for dark mode (e.g. the DM self-service response flow,
 * which hardcodes white surfaces), whose URL sits under a public resource so
 * DARK_MODE_EXCLUDED_PATH_PREFIXES can't express them without also excluding that
 * resource's other pages. Also exported for config/app-index.ts to interpolate — see
 * the note above.
 *
 * Patterns are case-insensitive to mirror React Router's default route matching.
 *
 * Temporary: removal is tracked in
 * `.claude/plans/cleanup-tech-debt/remove-dm-self-service-response-dark-mode-exclusion.md`.
 */
export const DARK_MODE_EXCLUDED_PATH_PATTERNS: readonly RegExp[] = [/^\/p\/[^/]+\/dm\/respond\/?$/i];

/**
 * Pages matching DARK_MODE_EXCLUDED_PATH_PREFIXES or DARK_MODE_EXCLUDED_PATH_PATTERNS
 * always render in light mode regardless of the user's dark-mode preference. This is the
 * single source of truth for that exclusion, consumed both server-side (to skip injecting
 * the dark-mode bootstrap script) and client-side (to reconcile the `.dark` class on SPA
 * navigation).
 */
export function isDarkModeExcludedPath(pathname: string): boolean {
	return (
		DARK_MODE_EXCLUDED_PATH_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)) ||
		DARK_MODE_EXCLUDED_PATH_PATTERNS.some((pattern) => pattern.test(pathname))
	);
}
